import { notifyApiError } from '@lib/bugsnag';

import { validateEmail, validatePhone } from '@utils/helpers';

/**
 * Contact utilities for email, phone, and WhatsApp handling
 * Shared across shift cards and profile components
 */

export const createEmailHref = (email: string | null | undefined): string | undefined => {
  if (!email) return;

  if (!validateEmail(email)) {
    notifyApiError(
      new Error(`Invalid email address: ${email}`),
      'Invalid email address for mailto link'
    );
    return;
  }

  return `mailto:${email}`;
};

export const createPhoneHref = (phone: string | null | undefined): string | undefined => {
  if (!phone) return;

  const cleanPhone = phone.replace(/\s/g, '');
  const phoneForValidation = cleanPhone.startsWith('+31') ? cleanPhone.substring(3) : cleanPhone;

  if (!validatePhone(phoneForValidation)) {
    notifyApiError(
      new Error(`Invalid phone number: ${phone}`),
      'Invalid phone number for tel link'
    );
    return;
  }

  return `tel:${phone}`;
};

export const openWhatsApp = (phone: string | null | undefined): void => {
  if (!phone) return;

  const cleanPhone = phone.replace(/\s/g, '');
  const phoneForValidation = cleanPhone.startsWith('+31') ? cleanPhone.substring(3) : cleanPhone;

  if (!validatePhone(phoneForValidation)) {
    console.warn('Invalid phone number for WhatsApp:', phone);
    return;
  }

  const whatsappNumber = cleanPhone.startsWith('+') ? cleanPhone.substring(1) : cleanPhone;
  window.open(`https://wa.me/${whatsappNumber}`, '_blank', 'noopener,noreferrer');
};

export const contactHelpers = {
  createEmailHref,
  createPhoneHref,
  openWhatsApp,
}; 